import { render, staticRenderFns } from "./modal2.vue?vue&type=template&id=1e1475a3&scoped=true"
import script from "./modal2.vue?vue&type=script&lang=js"
export * from "./modal2.vue?vue&type=script&lang=js"
import style0 from "./modal2.vue?vue&type=style&index=0&id=1e1475a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1475a3",
  null
  
)

export default component.exports